import utils from '../utils';

class ReadMoreLess {
  constructor(options = {}) {
    this.config = {
      readMore: document.querySelectorAll('[href=js-readmore]'),
      readLess: document.querySelectorAll('[href=js-readless]'),
      dots: false,
      ...options
    };
  }

  static wrapElement(element) {
    const parentsUntil = utils.getParentsUntil(element.parentNode, '.text-container');
    if (parentsUntil) {
      parentsUntil.forEach(el => {
        el.childNodes.forEach(ch => {
          if (ch.nodeType === 3 && ch.data.trim().length > 0) {
            const span = document.createElement('span');
            el.insertBefore(span, ch);
            span.appendChild(ch);
          }
        });
      });
    }
  }

  init() {
    const { readMore, readLess } = this.config;

    readMore.forEach(element => {
      element.classList.add('c-readmore__more');
      element.addEventListener('click', e => {
        e.preventDefault();
        element.parentNode.classList.remove('has-siblings-hidden');
      });

      ReadMoreLess.wrapElement(element);

      element.parentNode.classList.add('c-readmore', 'js-readmore-parent', 'has-siblings-hidden');
    });

    readLess.forEach(element => {
      element.classList.add('c-readmore__less');
      element.addEventListener('click', e => {
        e.preventDefault();
        const moreLink = element.closest('div').getElementsByClassName('js-readmore-parent')[0];
        moreLink.classList.add('has-siblings-hidden');
      });
    });
  }
}

export default ReadMoreLess;
